import { Patterns, Website, WebsiteKeys } from '@ag-common-lib/public-api';
import { Injectable } from '@angular/core';
import { BaseFormService } from '../../../../utils/base-form-service';

@Injectable()
export class WebsiteFormService extends BaseFormService<Website> {
  constructor() {
    super();
  }

  getFormData = (website: Partial<Website>) => {
    this.formData = new Proxy(website, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];

        if (value !== prevValue) {
          this.formChangesDetector.handleChange(prop, value, prevValue);
          Reflect.set(target, prop, value, receiver);

          switch (prop) {
            case WebsiteKeys.url:
              const url = value;
              const regExp = Patterns.URL_PATTERN_PROTOCOL_REGEXP as RegExp;
              if (!regExp.test(url)) {
                Object.assign(this.formData, {
                  [WebsiteKeys.url]: `https://${url}`,
                });
              }
              break;
          }
        }
        return true;
      },
    });

    return this.formData;
  };
}
